import component from './SpreadViewerAccessOptions.vue'
export default component
